var map = {
	"./zwzly_01.png": 7945,
	"./zwzly_02.png": 1858,
	"./zwzly_03.png": 2987,
	"./zwzly_04.png": 3076,
	"./zwzly_05.png": 9757,
	"./zwzly_06.png": 8550,
	"./zwzly_07.png": 7567,
	"./zwzly_08.png": 2616,
	"./zwzly_09.png": 3745,
	"./zwzly_10.png": 59,
	"./zwzly_11.png": 1058,
	"./zwzly_12.png": 6201,
	"./zwzly_13.png": 1376,
	"./zwzly_14.png": 31,
	"./zwzly_15.png": 1942,
	"./zwzly_16.png": 2621,
	"./zwzly_17.png": 6468,
	"./zwzly_18.png": 339,
	"./zwzly_19.png": 8762,
	"./zwzly_20.png": 8458,
	"./zwzly_21.png": 9219,
	"./zwzly_22.png": 4728,
	"./zwzly_23.png": 7441,
	"./zwzly_24.png": 4350,
	"./zwzly_25.png": 4343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1981;